<!-- Main Action Header Area -->
<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 p-3">
  <button type="button" class="btn btn-sm btn-primary px-3 shadow-sm d-inline-flex align-items-center gap-2 py-2"
    data-bs-toggle="modal" data-bs-target="#uploadCSVModal">
    <i class="fa-solid fa-cloud-arrow-up"></i>
    <span class="d-none d-sm-inline">Upload CSV</span>
  </button>
</div>

<!-- Responsive Log Data Table Grid -->
<div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100">
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0">

      <thead
        class="table-light text-body-secondary small text-uppercase text-nowrap border-bottom font-monospace tracking-wider">
        <tr>
          <th scope="col" class="ps-3" width="70">No</th>
          <th scope="col">File Name</th>
          <th scope="col">Start Serial</th>
          <th scope="col">End Serial</th>
          <th scope="col">Count</th>
          <th scope="col" class="text-center" width="120">Status</th>
          <th scope="col">Reason</th>
        </tr>
      </thead>

      <tbody class="small text-body">
        @for (data of qrUploadList() | paginate: { itemsPerPage: pageSize(), currentPage: page(), totalItems: allTotal()
        }; track $index) {
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary font-monospace fw-medium">{{ data.srNo }}</td>
          <td class="fw-semibold">{{ data.uploadFileName }}</td>
          <td class="font-monospace">{{ data.startSerial }}</td>
          <td class="font-monospace">{{ data.endSerial }}</td>
          <td class="font-monospace">{{ data.count }}</td>

          <td class="text-center">
            <span class="badge px-2.5 py-1.5 rounded-pill font-xs fw-semibold tracking-wide" [ngClass]="{
                'bg-success-subtle text-success-emphasis border border-success-subtle': data.status === 'SUCCESS' || data.status === 'COMPLETED',
                'bg-danger-subtle text-danger-emphasis border border-danger-subtle': data.status === 'FAIL' || data.status === 'FAILED',
                'bg-warning-subtle text-warning-emphasis border border-warning-subtle': data.status === 'PENDING' || data.status === 'PROCESSING'
              }">
              {{ data.status }}
            </span>
          </td>

          <td>
            <span class="text-body-secondary font-xs d-inline-block text-truncate" style="max-width: 250px;"
              [title]="data.reason">
              {{ data.reason || '-' }}
            </span>
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="7" class="text-center py-5 text-body-secondary">
            <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
              <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
              <span class="tracking-wider">No QR upload records found.</span>
            </div>
          </td>
        </tr>
        }
      </tbody>

    </table>
  </div>
</div>

<!-- Pagination Layout Anchor -->
<div class="d-flex justify-content-center mt-3">
  <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
    class="dashboard-pagination" (pageChange)="handlePageChange($event)">
  </pagination-controls>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- Modern Ingestion Processing Entry Dialog Modal -->
<div class="modal fade" id="uploadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>Upload QR Code CSV
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body px-4 py-4">
        <form [formGroup]="createQrUploadForm" class="d-flex flex-column gap-3">

          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Start Serial Number</label>
            <input type="text" class="form-control shadow-sm" formControlName="serialStart"
              placeholder="Enter start serial number" />
          </div>

          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">End Serial Number</label>
            <input type="text" class="form-control shadow-sm" formControlName="serialEnd"
              placeholder="Enter end serial number" />
          </div>

          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Total Count Quantity</label>
            <input type="number" class="form-control shadow-sm" formControlName="count"
              placeholder="Enter total count" />
          </div>

          <div>
            <label class="form-label small fw-bold text-body-secondary mb-1.5">Select Local CSV Ingestion File</label>
            <div class="input-group shadow-sm rounded">
              <input type="file" class="form-control file-input" formControlName="file" accept=".csv"
                (change)="onFileSelected($event)" />
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          [disabled]="!createQrUploadForm.valid || apiLoading()" (click)="uploadQRFile()">
          @if (apiLoading()) {
          <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
          <span>Uploading...</span>
          } @else {
          <span>Upload QR Codes <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>